module.exports = __webpack_public_path__ + "img/pdf.d9155fca.jpg";